import Brochure from '@/assets/pdf/en-US/ezyMedical/Brochure Ezy-Medical ENG.pdf';
import ClaimEzyMed from '@/assets/pdf/en-US/ezyMedical/En_ELIB_EzyMedical_ClaimGuide.pdf';
import BenefitEzMed from '@/assets/pdf/en-US/ezyMedical/En_ELIB_EzyMedical_Cont.pdf';
import DeclarationEzyMed from '@/assets/pdf/en-US/ezyMedical/En_ELIB_EzyMedical_Declaration.pdf';
import UncoveredEzMed from '@/assets/pdf/en-US/ezyMedical/En_ELIB_EzyMedical_Exclusion.pdf';
import PDS from '@/assets/pdf/en-US/ezyMedical/PDS_EzyMedical (EV).pdf';
import FAQ from '@/assets/pdf/en-US/ezyMedical/FAQ_EzyMedical (EV).pdf';
import PolicyContract from '@/assets/pdf/en-US/ezyMedical/Policy Contract_EzyMedical (EV).pdf';
import PremiumTable from '@/assets/pdf/en-US/ezyMedical/Premium Table - EzyMedical (EV).pdf';
import BenefitIMedic from '@/assets/pdf/en-US/iMedical/En_EFTB_iMedical_Cont.pdf';
import DeclarationIMed from '@/assets/pdf/en-US/iMedical/En_EFTB_iMedical_Declaration.pdf';
import UncoveredIMedic from '@/assets/pdf/en-US/iMedical/En_EFTB_iMedical_Exclusion.pdf';
import ClaimIMed from '@/assets/pdf/en-US/iMedical/En_ELIB_iMedical_ClaimGuide.pdf';
import ContributionRates from '@/assets/pdf/en-US/iMedical/i-MedicalCard Elite_Annual Contribution Rates.pdf';
import Brochure_iMedical from '@/assets/pdf/en-US/iMedical/i-MedicalCard Elite_e-Flyer.pdf';
import PDS_iMedical from '@/assets/pdf/en-US/iMedical/i-MedicalCard Elite_PDS.pdf';
import ShariahConcepts from '@/assets/pdf/en-US/iMedical/i-MedicalCard Elite_Shariah Concepts.pdf';
import TakafulCertificate from '@/assets/pdf/en-US/iMedical/Policy Contract_i-MedicalCard (EV).pdf';
import FAQ_iMedical from '@/assets/pdf/en-US/iMedical/FAQ_iMCE (EV).pdf';
import { Product } from '@/data/enums/product';

export default {
  downloadDocuments: 'Download Documents',
  campaignTnc: 'Campaign Terms and Conditions',
  [Product.EzyMedical]: {
    Benefit: BenefitEzMed,
    Uncovered: UncoveredEzMed,
    Declaration: DeclarationEzyMed,
    ClaimGuide: ClaimEzyMed,
    documents: [
      {
        name: 'Brochure',
        file: Brochure,
      },
      {
        name: 'FAQ',
        file: FAQ,
      },
      {
        name: 'Product Disclosure Sheet (PDS)',
        file: PDS,
      },
      {
        name: 'Policy Contract',
        file: PolicyContract,
      },
      {
        name: 'Annual Premium Rate Table',
        file: PremiumTable,
      },
      // {
      //   name: 'Premium Refund Table',
      //   file: PremiumRefundTable,
      // },
    ],
  },
  [Product.iMedicalCard]: {
    Benefit: BenefitIMedic,
    Uncovered: UncoveredIMedic,
    Declaration: DeclarationIMed,
    ClaimGuide: ClaimIMed,
    documents: [
      {
        name: 'Brochure',
        file: Brochure_iMedical,
      },
      {
        name: 'Product Disclosure Sheet (PDS)',
        file: PDS_iMedical,
      },
      {
        name: 'Takaful Certificate',
        file: TakafulCertificate,
      },
      {
        name: 'FAQ',
        file: FAQ_iMedical,
      },
      {
        name: 'Annual Contribution Rates Table',
        file: ContributionRates,
      },
      // {
      //   name: 'Refund of Contribution Schedule',
      //   file: ContributionSchedule,
      // },
      {
        name: 'Shariah Concepts',
        file: ShariahConcepts,
      },
    ],
  },
  [Product.EasyHealth]: {},
};
